import { Panel, trendClass, trendGlyph } from "../Panel"
import type { RiskOverview } from "../dashboard-types"

export function RiskGauge({ risk, demo }: { risk: RiskOverview; demo?: boolean }) {
  const labelColor =
    risk.label === "CRITICAL" ? "text-red-400" :
    risk.label === "ELEVATED" ? "text-orange-400" :
    risk.label === "GUARDED" ? "text-amber-400" :
    "text-emerald-400"
  const ring =
    risk.label === "CRITICAL" ? "#ef4444" :
    risk.label === "ELEVATED" ? "#f97316" :
    risk.label === "GUARDED" ? "#f59e0b" :
    "#10b981"
  const deg = Math.max(0, Math.min(360, (risk.score / 100) * 360))
  return (
    <Panel title="Supply Chain Risk Overview" live demo={demo} helpText="Composite of all lane scores, weighted by severity">
      <div className="p-4 flex items-center justify-around gap-3 h-full">
        <div
          className="relative w-[130px] h-[130px] rounded-full shrink-0"
          style={{
            background: `conic-gradient(${ring} ${deg}deg, var(--surface-alt) 0)`,
          }}
        >
          <div className="absolute inset-[10px] bg-[color:var(--surface)] rounded-full flex flex-col items-center justify-center">
            <div className={`text-3xl font-bold tabular-nums ${labelColor}`}>{risk.score}</div>
            <div className={`text-[9px] uppercase tracking-[0.18em] mt-0.5 ${labelColor}`}>{risk.label}</div>
          </div>
        </div>
        <div className="flex flex-col gap-2 text-xs min-w-0">
          <div>
            <div className="text-[9px] uppercase tracking-widest text-[color:var(--text-dim)]">Trend</div>
            <div className={`text-sm ${trendClass(risk.trend)}`}>
              {trendGlyph(risk.trend)} {risk.trend}
            </div>
          </div>
          <div>
            <div className="text-[9px] uppercase tracking-widest text-[color:var(--text-dim)]">Sample</div>
            <div className="text-sm text-[color:var(--text)]">{risk.sample_n} lanes</div>
          </div>
          <div>
            <div className="text-[9px] uppercase tracking-widest text-[color:var(--text-dim)]">State</div>
            <div className={`text-sm ${labelColor}`}>{risk.label}</div>
          </div>
        </div>
      </div>
    </Panel>
  )
}
